import { Button, CircularProgress } from "@mui/material";
import { Input, MuiBox } from "components/atoms";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { FormikProvider, useFormik } from "formik";
import * as Yup from "yup";
import { Message, Subject } from "utils/validation/CommonValidation";
import { AddFeedbackAction } from "store/middlewares/general";

const FeedbackTab = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleSubmit = (values) => {
    setLoading(true);
    dispatch(
      AddFeedbackAction({
        ...values,
        onSuccess: () => setLoading(false),
        onError: () => setLoading(false),
      }),
    );
  };
  const formik = useFormik({
    initialValues: {
      subject: "",
      message: "",
    },
    validationSchema: Yup.object({
      subject: Subject(t),
      message: Message(t),
    }),
    validateOnChange: false,
    validateOnBlur: false,
    enableReinitialize: true,
    onSubmit: handleSubmit,
  });

  return (
    <MuiBox onSubmit={formik.handleSubmit} component={"form"}>
      <FormikProvider value={formik}>
        <MuiBox
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "16px",
            p: "20px",
          }}
        >
          <Input
            placeholder={t("modal.helpFeedback.enterSubject")}
            label={t("modal.helpFeedback.subject")}
            name={"subject"}
            value={formik.values.subject}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            errorMsg={formik.errors.subject}
            error={formik.touched.subject && formik.errors.subject}
            isBorderColor={true}
            isSpace={true}
            isTextOnly={true}
            maxCharacter={200}
          />
          <Input
            placeholder={t("modal.helpFeedback.enterMessage")}
            label={t("modal.helpFeedback.message")}
            name={"message"}
            value={formik.values.message}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            errorMsg={formik.errors.message}
            error={formik.touched.message && formik.errors.message}
            isBorderColor={true}
            isSpace={true}
            rows="4"
            maxCharacter={2000}
            multiline={true}
          />
        </MuiBox>
        <MuiBox
          sx={{
            display: "flex",
            gap: "12px",
            bgcolor: "background.gray200",
            p: "16px 20px",
            justifyContent: "end",
            flexWrap: { xs: "wrap-reverse", sm: "nowrap" },
          }}
        >
          {/* <Button
          variant="whiteContained"
          sx={{
            width: "fit-content",
            border: "2px solid",
            borderColor: "background.blue600",
          }}
          onClick={() => dispatch(closeCenterModal())}
        >
          <MuiTypography
            variant="14"
            component={"span"}
            textAlign={"center"}
            fontWeight={"500"}
            color="primary.main"
          >
            {t("commonButton.cancel")}
          </MuiTypography>
        </Button> */}
          <Button
            type="submit"
            variant="contained"
            disabled={loading}
            sx={{
              width: "fit-content",
            }}
          >
            {loading ? (
              <CircularProgress
                size="22px"
                sx={{ color: "background.white" }}
              />
            ) : (
              t("modal.helpFeedback.submit")
            )}
          </Button>
        </MuiBox>
      </FormikProvider>
    </MuiBox>
  );
};

export default FeedbackTab;
